import { css } from "@emotion/react";
import { useMediaQuery } from "react-responsive";

export const FONT = (type: string, size: number, weight: number, lineHeight: number = 1.5) => {
    let result = type === "cormorant" && "Cormorant";

    if (type === "notoSerif") {
        result = "Noto Serif KR";
    }

    if (type === "pretendard") {
        result = "Pretendard Variable";
    }

    return css`
        font-family: ${result} !important;
        font-size: ${size}px !important;
        font-weight: ${weight} !important;
        line-height: ${lineHeight} !important;
    `;
};

export const FLEX = {
    normal: (horizon: string, vertical: string, type: string = "flex") => {
        return css`
            display: ${type};
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },

    row: (horizon: string, vertical: string, columnGap: number, type: string = "flex") => {
        return css`
            display: ${type};
            flex-direction: row;
            column-gap: ${columnGap}px;
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },

    column: (horizon: string, vertical: string, rowGap: number, type: string = "flex") => {
        return css`
            display: ${type};
            flex-direction: column;
            row-gap: ${rowGap}px;
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },
};

export const RADIUS = (radius: number) => {
    const result = radius < 25 ? `${radius * 4}px` : `${radius}%`;

    return css`
        border-radius: ${result};
    `;
};

export const MEDIA = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const isTablet = useMediaQuery({ query: "(max-width: 1024px)" });
    const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
    const isDesktop = useMediaQuery({ query: "(max-width: 1920px)" });

    return { isMobile, isTablet, isLaptop, isDesktop };
};
